/**
 * Copyright (c) 2024 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { StyleSheet } from 'aphrodite';
import { colors, fonts } from '@blend/consumer-components';
import { useVideoContext } from '../../../../contexts/videoProvider/videoContext';
import { ActionButton } from '@components/ActionButton';

const styles = StyleSheet.create({
  button: {
    paddingLeft: 0,
    paddingRight: 0,
    fontSize: 14,
    fontWeight: fonts.weight.medium,
    height: 50,
  },
});

export const ClosedCaptionsToggle: React.FC<{}> = () => {
  const { videoProvider, closedCaptions, toggleClosedCaptioning } = useVideoContext();

  const displayText = closedCaptions.isEnabled ? 'Disable closed captions' : 'Enable closed captions';

  return (
    <ActionButton
      data-dd-privacy="allow"
      sizing={'full'}
      option={'secondary'}
      onClick={toggleClosedCaptioning}
      color={colors.catalyst}
      customStyle={styles.button}
      disabled={!videoProvider.isCallConnected()}
    >
      {displayText}
    </ActionButton>
  );
};
